import { useApolloClient } from '@apollo/client';
import { useLoggedInUser } from '@ApplicationWide/AppConfig';
import { useAsyncFn, useLocalStorage } from 'react-use';
import MASQUERADE_AS_MUTATION from './masqueradeAs.query.graphql';
import STOP_MASQUERADE_MUTATION from './stopMasquerade.query.graphql';
import { removeCurrentViewAsUserId, setCurrentViewAsUserId } from '@ApplicationWide/fetchConfigHelper';

export default function useMasqueradeState() {
  const apolloClient = useApolloClient();
  const { user } = useLoggedInUser();
  const [, , removeLegacyMasqueradeInfo] = useLocalStorage('current_admin');
  const [masqueradeInfo, setMasqueradeInfo, removeMasqueradeInfo] = useLocalStorage('admin-masquerade-info');
  const [masqueradeAsState, masqueradeAs] = useAsyncFn(
    async (userIdToMasquerade) => {
      await apolloClient.mutate({ mutation: MASQUERADE_AS_MUTATION, variables: { userId: userIdToMasquerade } });
      setMasqueradeInfo(user?.id);
      setCurrentViewAsUserId(userIdToMasquerade);

      // force full reload of page to make sure no lingering state
      window.location.reload();
    },
    [apolloClient, setMasqueradeInfo, user?.id],
  );
  const [stopMasqueradeState, stopMasquerade] = useAsyncFn(async () => {
    await apolloClient.mutate({ mutation: STOP_MASQUERADE_MUTATION, variables: { userId: masqueradeInfo } });
    removeMasqueradeInfo();
    removeCurrentViewAsUserId();
    // cleaning up just to be sure that if you return to the old UI there isn't a problem
    removeLegacyMasqueradeInfo();
    // force full reload of page to make sure no lingering state
    window.location.reload();
  }, [apolloClient, masqueradeInfo, removeLegacyMasqueradeInfo, removeMasqueradeInfo]);

  const error = masqueradeAsState.error || stopMasqueradeState.error;
  if (error) throw error;

  return {
    masqueradeAs,
    stopMasquerade,
    isMasquerading: Boolean(masqueradeInfo),
    masqueradeInfo,
  };
}
